/* eslint-disable */

/**
 * Dependencies:
 * - Custom select component
 *
 * Required translation strings:
 * - addToCart
 * - noStock
 * - noVariant
 * - onlyXLeft
 */
// BSS Product Add-on

if (!customElements.get('variant-add-on')) {
  class VariantAddon extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.item-add-on');
      this.optionSelectors = this.querySelectorAll('.option-selector');
      this.data = this.getProductData();
      this.variant = this.getSelectedVariant();

      this.updateAvailability();
      this.updateAddToCartButton();
      this.hideUnavailableColors();

      // fallback
      if (!this.variant && this.data?.product?.variants?.length) {
        this.variant = this.data.product.variants[0];
      }

      this.updatePrice();
      this.updateMedia();

      this.addEventListener('change', this.handleVariantChange.bind(this));

      const btnAddOn = this.parentNode.querySelector('[name="atc-add-on"]');
      if (btnAddOn) {
        btnAddOn.addEventListener('click', this.updateVariantInput.bind(this));
      }

      // ✅ expandera/collapsa vid klick på header
      const header = this.section.querySelector('.item-header');
      if (header) {
        header.addEventListener('click', () => {
          const body = this.section.querySelector('.item-body');
          const expanded = header.getAttribute('aria-expanded') === 'true';
          header.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          if (body) {
            if (expanded) {
              body.setAttribute('hidden', '');
            } else {
              body.removeAttribute('hidden');
            }
          }
        });
      }
    }

    handleVariantChange(evt) {
      this.variant = this.getSelectedVariant();
      if (this.variant) this.updateMedia();
      this.updateAddToCartButton();
      this.updateAvailability();
      this.hideUnavailableColors();
      this.updatePrice();
      VariantAddon.updateLabelText(evt);
    }

    updateAddToCartButton() {
      if (this.variant && this.variant.title !== 'Default Title') {
        const variantAvailable = this.variant?.available;
        const unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant;
        this.addBtn = this.section.querySelector('[name="atc-add-on"]');
        if (this.addBtn) {
          this.addBtn.textContent = variantAvailable
            ? this.addBtn.dataset.addToCartText
            : unavailableStr;
          this.addBtn.disabled = !variantAvailable;
        }
      }
    }

    updateAvailability() {
      let currVariant = this.variant || { options: this.getSelectedOptions() };

      const updateOptionAvailability = (optionEl, available, soldout) => {
        const text = soldout ? theme.strings.noStock : theme.strings.noVariant;
        optionEl.classList.toggle('is-unavailable', !available);
        if (optionEl.classList.contains('custom-select__option')) {
          const em = optionEl.querySelector('em');
          if (em) em.hidden = available;
          if (!available) {
            if (em) em.textContent = text;
            else optionEl.innerHTML += ' <em class="pointer-events-none">' + text + '</em>';
          }
        } else if (!available) {
          optionEl.nextElementSibling?.setAttribute('title', text);
        } else {
          optionEl.nextElementSibling?.removeAttribute('title');
        }
      };

      this.querySelectorAll('.js-option').forEach((opt) => {
        updateOptionAvailability(opt, false, false);
      });

      this.optionSelectors.forEach((selector, selectorIndex) => {
        this.data.product.variants.forEach((variant) => {
          let matchCount = 0;
          variant.options.forEach((option, optionIndex) => {
            if (option === currVariant.options[optionIndex] && optionIndex !== selectorIndex) {
              matchCount++;
            }
          });
          if (matchCount === currVariant.options.length - 1) {
            const options = selector.querySelectorAll('.js-option');
            const optionEl = Array.from(options).find((opt) => {
              if (selector.dataset.selectorType === 'dropdown') {
                return opt.dataset.value === variant.options[selectorIndex];
              }
              return opt.value === variant.options[selectorIndex];
            });
            if (optionEl) {
              updateOptionAvailability(optionEl, variant.available, !variant.available);
              optionEl.setAttribute("data-variant-id", variant.id); // ✅ KOPPLA ID
            }
          }
        });
      });
    }

    static updateLabelText(evt) {
      const selector = evt.target.closest('.option-selector');
      if (!selector || selector.dataset.selectorType === 'dropdown') return;
      const colorText = selector.querySelector('.js-color-text');
      if (!colorText) return;
      const valEl = evt.target.nextElementSibling?.querySelector('.js-value');
      if (valEl) colorText.textContent = valEl.textContent;
    }

    updateMedia() {
      this.mediaGallery = this.section.querySelector('.media');
      if (!this.mediaGallery || !this.variant) return;
      this.mediaGallery.querySelectorAll('.media-item').forEach((media) => {
        media.classList.toggle('hidden', !media.classList.contains('add-on-' + this.variant.id));
      });
    }

    updatePrice() {
      this.price = this.price || this.section.querySelector('.addon-info__price > .price');
      if (!this.price || !this.variant) return;

      const formatted = this.data.formatted[this.variant.id];
      const priceCurrentEl = this.price.querySelector('.price__current');
      const priceWasEl = this.price.querySelector('.price__was');
      const unitPriceEl = this.price.querySelector('.unit-price');

      if (priceWasEl) {
        if (formatted.discountOldPrice) {
          let old_price = formatted.discountOldPrice,
            discount = formatted.discountNewPrice,
            symbol = formatted.symbol,
            currency_rate = Shopify.currency.rate,
            discount_new = discount * currency_rate,
            new_price = (old_price - discount_new) / 100;
          priceCurrentEl.innerHTML = new_price.toLocaleString('sv-SE', {
            minimumFractionDigits: 2,
          }) + ' ' + symbol;
        } else {
          priceCurrentEl.innerHTML = formatted.discountPrice || '';
        }
        priceWasEl.innerHTML = formatted.price || formatted.compareAtPrice;
      } else {
        priceCurrentEl.innerHTML = formatted.price;
      }

      if (this.variant.unit_price_measurement) {
        const valueEl = this.price.querySelector('.unit-price__price');
        const unitEl = this.price.querySelector('.unit-price__unit');
        valueEl.innerHTML = formatted.unitPrice;
        const ref = this.variant.unit_price_measurement;
        unitEl.textContent = ref.reference_value === 1 ? ref.reference_unit : (ref.reference_value + ' ' + ref.reference_unit);
      }
      unitPriceEl.hidden = !this.variant.unit_price_measurement;

      this.price.classList.toggle('price--on-sale', this.variant.compare_at_price > this.variant.price || priceWasEl);
      this.price.classList.toggle('price--sold-out', !this.variant.available);

      if (this.variant) {
  this.price.querySelector('.price__default').hidden = false;
  this.price.querySelector('.price__no-variant').hidden = true;
} else {
  this.price.querySelector('.price__default').hidden = true;
  this.price.querySelector('.price__no-variant').hidden = false;
}
    }

    updateVariantInput() {
      const addOnSelectBox = this.section.closest(`.add-on-selectbox`);
      const input = addOnSelectBox.querySelector(`input[name="id-add-on"]`);

      // ✅ alltid korrekt variant-id, hämta färsk variant
      this.variant = this.getSelectedVariant();

      if (input) input.value = this.variant ? this.variant.id : "";

      addOnSelectBox.classList.remove('active');
      this.updateAddOnSelected();
      this.updateAddToCartButton();
    }

    updateAddOnSelected() {
      let html = '';
      const addOnSelectBox = this.section.closest(`.add-on-selectbox`);
      const labelEl = addOnSelectBox.querySelector(`.selected-add-on-product`);

      if (this.variant) {
        this.data.product.options.forEach((opt, i) => {
          if (opt && this.variant.options[i]) {
            html += `<span><strong>${opt}</strong>: ${this.variant.options[i]}</span>`;
          }
        });
      }

      if (labelEl) labelEl.innerHTML = this.data.product.title;
      const container = addOnSelectBox.querySelector(".add-on-selected");
      if (container) container.innerHTML = html;

      const removeBtn = addOnSelectBox.querySelector(".remove-add-on");
      if (removeBtn) removeBtn.classList.remove('hidden');
    }

    getSelectedOptions() {
      return Array.from(this.optionSelectors).map((selector) => {
        const checked = selector.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    getProductData() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }

    getSelectedVariant() {
      const selectedOptions = this.getSelectedOptions();
      return this.data.product.variants.find(
        (v) => v.options.every((val, idx) => val === selectedOptions[idx])
      );
    }

    getColorIndex() {
      try {
        const names = (this.data?.product?.options || []).map((o) =>
          typeof o === 'string' ? o.toLowerCase() : o?.name?.toLowerCase() || ''
        );
        return names.findIndex((n) => ['färg', 'farg', 'color', 'colour'].includes(n));
      } catch {
        return -1;
      }
    }

    hideUnavailableColors() {
      const colorIdx = this.getColorIndex();
      if (colorIdx < 0) return;
      const colorSelector = this.optionSelectors[colorIdx];
      if (!colorSelector) return;

      const availableColors = new Set(
        (this.data?.product?.variants || []).filter((v) => v.available).map((v) => v.options[colorIdx])
      );

      const inputs = colorSelector.querySelectorAll('.js-option');
      inputs.forEach((input) => {
        const val = input.value || input.dataset.value;
        const isAvailable = availableColors.has(val);
        const label = input.parentElement?.classList.contains('opt-wrapper')
          ? input.parentElement
          : input.nextElementSibling?.tagName === 'LABEL'
          ? input.nextElementSibling
          : null;
        if (label) {
          if (isAvailable) {
            input.style.removeProperty('display');
            label.style.removeProperty('display');
            input.disabled = false;
          } else {
            input.style.setProperty('display', 'none', 'important');
            label.style.setProperty('display', 'none', 'important');
            input.disabled = true;
          }
        }
      });

      const checked = colorSelector.querySelector('input:checked');
      if (checked && (checked.disabled || checked.style.display === 'none')) {
        const firstVisible = Array.from(inputs).find((i) => !i.disabled && i.style.display !== 'none');
        if (firstVisible) {
          firstVisible.checked = true;
          firstVisible.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
  }

  customElements.define('variant-add-on', VariantAddon);

  // toggle-knappar
  document.querySelectorAll('.binding-toggle .binding-btn').forEach((btn) => {
    btn.addEventListener('click', function () {
      this.closest('.binding-toggle').querySelectorAll('.binding-btn').forEach((b) => b.classList.remove('is-active'));
      this.classList.add('is-active');
    });
  });
}
